import React, { useEffect, useRef } from 'react';
import { useSpinradContext } from '../../context/SpinradContext';
import Stepper from '../../stepper';
import Wheel from '../wheel';
import { SidebarOv as SidebarOvBox } from './styles';

const SidebarOv: React.FC = () => {
  const { currentStep, spinning, pendingSpin } = useSpinradContext();
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (spinning || !pendingSpin) return;
    const el = scrollRef.current;
    if (!el) return;
    requestAnimationFrame(() => {
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
    });
  }, [spinning, pendingSpin]);

  return (
    <SidebarOvBox ref={scrollRef}>
      <Stepper currentStep={currentStep} variant="ov" />
      <Wheel />
    </SidebarOvBox>
  );
};

export default SidebarOv;
